import React,{ Component } from 'react'
import {Link } from "react-router-dom";

class Blogdetails extends Component {
     render(){
          return(
               <div>

<main>

 
    <div class="slider-area">
         <div class="slider-height2 d-flex align-items-center">
              <div class="container">
                   <div class="row">
                        <div class="col-xl-12">
                             <div class="hero-cap">
                                  <h2>Blog Details</h2>
                                  <nav aria-label="breadcrumb ">
                                       <ol class="breadcrumb">
                                       <li class="breadcrumb-item"><Link to="/">Home</Link></li>
                                       <li class="breadcrumb-item"><Link to="/">Blog Details</Link></li> 
                                       </ol>
                                  </nav>
                             </div>
                        </div>
                   </div>
              </div>
         </div>
    </div>
 
<section class="blog_area single-post-area section-padding">
   <div class="container">
      <div class="row">
         <div class="col-lg-8 posts-list">
            <div class="single-post">
               <div class="feature-img">
                  <img class="img-fluid" src="assets/img/blog/single_blog_1.png" alt="" />
               </div>
               <div class="blog_details">
                  <h2>Second divided from form fish beast made every of seas
                     all gathered us saying he our
                  </h2>
                  <ul class="blog-info-link mt-3 mb-4">
                     <li><Link to="/"><i class="fa fa-user"></i> Travel, Lifestyle</Link></li>
                     <li><Link to="/"><i class="fa fa-comments"></i> 03 Comments</Link></li>
                  </ul>
                  <p class="excert">
                     MCSE boot camps have its supporters and its detractors. Some people do not understand why you
                     should have to spend money on boot camp when you can get the MCSE study materials yourself at a
                     fraction of the camp price. However, who has the willpower
                  </p>
                  <p>
                     MCSE boot camps have its supporters and its detractors. Some people do not understand why you
                     should have to spend money on boot camp when you can get the MCSE study materials yourself at a
                     fraction of the camp price. However, who has the willpower to actually sit through a
                     self-imposed MCSE training. who has the willpower to actually
                  </p>
                  <div class="quote-wrapper">
                     <div class="quotes">
                        MCSE boot camps have its supporters and its detractors. Some people do not understand why you
                        should have to spend money on boot camp when you can get the MCSE study materials yourself at
                        a fraction of the camp price. However, who has the willpower to actually sit through a
                        self-imposed MCSE training.
                     </div>
                  </div>
                  <p>
                     MCSE boot camps have its supporters and its detractors. Some people do not understand why you
                     should have to spend money on boot camp when you can get the MCSE study materials yourself at a
                     fraction of the camp price. However, who has the willpower
                  </p>
                  <p>
                     MCSE boot camps have its supporters and its detractors. Some people do not understand why you
                     should have to spend money on boot camp when you can get the MCSE study materials yourself at a
                     fraction of the camp price. However, who has the willpower to actually sit through a
                     self-imposed MCSE training. who has the willpower to actually
                  </p>
               </div>
            </div>
            <div class="navigation-top">
               <div class="d-sm-flex justify-content-between text-center">
                  <p class="like-info"><span class="align-middle"><i class="fa fa-heart"></i></span> Lily and 4
                     people like this</p>
                  <div class="col-sm-4 text-center my-2 my-sm-0">
                     
                  </div>
                  <ul class="social-icons">
                     <li><Link to="/"><i class="fab fa-facebook-f"></i></Link></li>
                     <li><Link to="/"><i class="fab fa-twitter"></i></Link></li>
                     <li><Link to="/"><i class="fab fa-dribbble"></i></Link></li>
                     <li><Link to="/"><i class="fab fa-behance"></i></Link></li>
                  </ul>
               </div>
               <div class="navigation-area">
                  <div class="row">
                     <div
                        class="col-lg-6 col-md-6 col-12 nav-left flex-row d-flex justify-content-start align-items-center">
                        <div class="thumb">
                        <Link to="/">
                              <img class="img-fluid" src="assets/img/post/preview.png" alt="" />
                           </Link>
                        </div>
                        <div class="arrow">
                        <Link to="/">
                              <span class="lnr text-white ti-arrow-left"></span>
                           </Link>
                        </div>
                        <div class="detials">
                           <p>Prev Post</p>
                           <Link to="/">
                              <h4>Space The Final Frontier</h4>
                           </Link>
                        </div>
                     </div>
                     <div
                        class="col-lg-6 col-md-6 col-12 nav-right flex-row d-flex justify-content-end align-items-center">
                        <div class="detials">
                           <p>Next Post</p>
                           <Link to="/">
                              <h4>Telescopes 101</h4>
                           </Link>
                        </div>
                        <div class="arrow">
                        <Link to="/">
                              <span class="lnr text-white ti-arrow-right"></span>
                           </Link>
                        </div>
                        <div class="thumb">
                        <Link to="/">
                              <img class="img-fluid" src="assets/img/post/next.png" alt="" />
                           </Link>
                        </div>
                     </div>
                  </div>
               </div>
            </div>
            <div class="blog-author">
               <div class="media align-items-center">
                  <img src="assets/img/blog/author.png" alt="" />
                  <div class="media-body">
                  <Link to="/">
                        <h4>Harvard milan</h4>
                     </Link>
                     <p>Second divided from form fish beast made. Every of seas all gathered use saying you're, he
                        our dominion twon Second divided from</p>
                  </div>
               </div>
            </div>
            <div class="comments-area">
               <h4>05 Comments</h4>
               <div class="comment-list">
                  <div class="single-comment justify-content-between d-flex">
                     <div class="user justify-content-between d-flex">
                        <div class="thumb">
                           <img src="assets/img/comment/comment_1.png" alt="" />
                        </div>
                        <div class="desc">
                           <p class="comment">
                              Multiply sea night grass fourth day sea lesser rule open subdue female fill which them
                              Blessed, give fill lesser bearing multiply sea night grass fourth day sea lesser
                           </p>
                           <div class="d-flex justify-content-between">
                              <div class="d-flex align-items-center">
                                 <h5>
                                 <Link to="/">Emilly Blunt</Link>
                                 </h5>
                                 <p class="date">December 4, 2017 at 3:12 pm </p>
                              </div>
                              <div class="reply-btn">
                              <Link to="/" class="btn-reply text-uppercase">reply</Link>
                              </div>
                           </div>
                        </div>
                     </div>
                  </div>
               </div>
               <div class="comment-list">
                  <div class="single-comment justify-content-between d-flex">
                     <div class="user justify-content-between d-flex">
                        <div class="thumb">
                           <img src="assets/img/comment/comment_2.png" alt="" />
                        </div>
                        <div class="desc">
                           <p class="comment">
                              Multiply sea night grass fourth day sea lesser rule open subdue female fill which them
                              Blessed, give fill lesser bearing multiply sea night grass fourth day sea lesser
                           </p>
                           <div class="d-flex justify-content-between">
                              <div class="d-flex align-items-center">
                                 <h5>
                                 <Link to="/">Emilly Blunt</Link>
                                 </h5>
                                 <p class="date">December 4, 2017 at 3:12 pm </p>
                              </div>
                              <div class="reply-btn">
                              <Link to="/" class="btn-reply text-uppercase">reply</Link>
                              </div>
                           </div>
                        </div>
                     </div>
                  </div>
               </div>
               <div class="comment-list">
                  <div class="single-comment justify-content-between d-flex">
                     <div class="user justify-content-between d-flex">
                        <div class="thumb">
                           <img src="assets/img/comment/comment_3.png" alt="" />
                        </div>
                        <div class="desc">
                           <p class="comment">
                              Multiply sea night grass fourth day sea lesser rule open subdue female fill which them
                              Blessed, give fill lesser bearing multiply sea night grass fourth day sea lesser
                           </p>
                           <div class="d-flex justify-content-between">
                              <div class="d-flex align-items-center">
                                 <h5>
                                 <Link to="/">Emilly Blunt</Link>
                                 </h5>
                                 <p class="date">December 4, 2017 at 3:12 pm </p>
                              </div>
                              <div class="reply-btn">
                              <Link to="/" class="btn-reply text-uppercase">reply</Link>
                              </div>
                           </div>
                        </div>
                     </div>
                  </div>
               </div>
            </div>
            <div class="comment-form">
               <h4>Leave a Reply</h4>
               <form class="form-contact comment_form" action="#" id="commentForm">
                  <div class="row">
                     <div class="col-12">
                        <div class="form-group">
                           <textarea class="form-control w-100" name="comment" id="comment" cols="30" rows="9"
                              placeholder="Write Comment"></textarea>
                        </div>
                     </div>
                     <div class="col-sm-6">
                        <div class="form-group">
                           <input class="form-control" name="name" id="name" type="text" placeholder="Name" />
                        </div>
                     </div>
                     <div class="col-sm-6">
                        <div class="form-group">
                           <input class="form-control" name="email" id="email" type="email" placeholder="Email" />
                        </div>
                     </div>
                     <div class="col-12">
                        <div class="form-group">
                           <input class="form-control" name="website" id="website" type="text" placeholder="Website" />
                        </div>
                     </div>
                  </div>
                  <div class="form-group">
                     <button type="submit" class="button button-contactForm btn_1 boxed-btn">Send Message</button>
                  </div>
               </form>
            </div>
         </div>
         <div class="col-lg-4">
            <div class="blog_right_sidebar">
               <aside class="single_sidebar_widget search_widget">
                  <form action="#">
                     <div class="form-group">
                        <div class="input-group mb-3">
                           <input type="text" class="form-control" placeholder='Search Keyword'
                              onfocus="this.placeholder = ''" onblur="this.placeholder = 'Search Keyword'" />
                           <div class="input-group-append">
                              <button class="btns" type="button"><i class="ti-search"></i></button>
                           </div>
                        </div>
                     </div>
                     <button class="button rounded-0 primary-bg text-white w-100 btn_1 boxed-btn"
                        type="submit">Search</button>
                  </form>
               </aside>
               <aside class="single_sidebar_widget post_category_widget">
                  <h4 class="widget_title">Category</h4>
                  <ul class="list cat-list">
                     <li>
                     <Link to="/" class="d-flex">
                           <p>Resaurant food</p>
                           <p>(37)</p>
                        </Link>
                     </li>
                     <li>
                     <Link to="/" class="d-flex">
                           <p>Travel news</p>
                           <p>(10)</p>
                        </Link>
                     </li>
                     <li>
                     <Link to="/" class="d-flex">
                           <p>Modern technology</p>
                           <p>(03)</p>
                        </Link>
                     </li>
                     <li>
                     <Link to="/" class="d-flex">
                           <p>Product</p>
                           <p>(11)</p>
                        </Link>
                     </li>
                     <li>
                     <Link to="/" class="d-flex">
                           <p>Inspiration</p>
                           <p>(21)</p>
                        </Link>
                     </li>
                     <li>
                     <Link to="/" class="d-flex">
                           <p>Health Care</p>
                           <p>(21)</p>
                        </Link>
                     </li>
                  </ul>
               </aside>
               <aside class="single_sidebar_widget popular_post_widget">
                  <h3 class="widget_title">Recent Post</h3>
                  <div class="media post_item">
                     <img src="assets/img/post/post_1.png" alt="post" />
                     <div class="media-body">
                     <Link to="/">
                           <h3>From life was you fish...</h3>
                        </Link>
                        <p>January 12, 2019</p>
                     </div>
                  </div>
                  <div class="media post_item">
                     <img src="assets/img/post/post_2.png" alt="post" />
                     <div class="media-body">
                     <Link to="/">
                           <h3>The Amazing Hubble</h3>
                        </Link>
                        <p>02 Hours ago</p>
                     </div>
                  </div>
                  <div class="media post_item">
                     <img src="assets/img/post/post_3.png" alt="post" />
                     <div class="media-body">
                     <Link to="/">
                           <h3>Astronomy Or Astrology</h3>
                        </Link>
                        <p>03 Hours ago</p>
                     </div>
                  </div>
                  <div class="media post_item">
                     <img src="assets/img/post/post_4.png" alt="post" />
                     <div class="media-body">
                     <Link to="/">
                           <h3>Asteroids telescope</h3>
                        </Link>
                        <p>01 Hours ago</p>
                     </div>
                  </div>
               </aside>
               <aside class="single_sidebar_widget tag_cloud_widget">
                  <h4 class="widget_title">Tag Clouds</h4>
                  <ul class="list">
                     <li>
                     <Link to="/">project</Link>
                     </li>
                     <li>
                     <Link to="/">love</Link>
                     </li>
                     <li>
                     <Link to="/">technology</Link>
                     </li>
                     <li>
                     <Link to="/">travel</Link>
                     </li>
                     <li>
                     <Link to="/">restaurant</Link>
                     </li>
                     <li>
                     <Link to="/">life style</Link>
                     </li>
                     <li>
                     <Link to="/">design</Link>
                     </li>
                     <li>
                     <Link to="/">illustration</Link>
                     </li>
                  </ul>
               </aside>
               <aside class="single_sidebar_widget instagram_feeds">
                  <h4 class="widget_title">Instagram Feeds</h4>
                  <ul class="instagram_row flex-wrap">
                     <li>
                     <Link to="/">
                           <img class="img-fluid" src="assets/img/post/post_5.png" alt="" />
                        </Link>
                     </li>
                     <li>
                     <Link to="/">
                           <img class="img-fluid" src="assets/img/post/post_6.png" alt="" />
                        </Link>
                     </li>
                     <li>
                     <Link to="/">
                           <img class="img-fluid" src="assets/img/post/post_7.png" alt="" />
                        </Link>
                     </li>
                     <li>
                     <Link to="/">
                           <img class="img-fluid" src="assets/img/post/post_8.png" alt="" />
                        </Link>
                     </li>
                     <li>
                     <Link to="/">
                           <img class="img-fluid" src="assets/img/post/post_9.png" alt="" />
                        </Link>
                     </li>
                     <li>
                     <Link to="/">
                           <img class="img-fluid" src="assets/img/post/post_10.png" alt="" />
                        </Link>
                     </li>
                  </ul>
               </aside>
               <aside class="single_sidebar_widget newsletter_widget">
                  <h4 class="widget_title">Newsletter</h4>
                  <form action="#">
                     <div class="form-group">
                        <input type="email" class="form-control" onfocus="this.placeholder = ''"
                           onblur="this.placeholder = 'Enter email'" placeholder='Enter email' required />
                     </div>
                     <button class="button rounded-0 primary-bg text-white w-100 btn_1 boxed-btn"
                        type="submit">Subscribe</button>
                  </form>
               </aside>
            </div>
         </div>
      </div>
   </div>
</section>
 

</main>



               </div>
          )
     }
}

export default Blogdetails 
